module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/1_fb410d81e04a669be343700049ef7d54.png";